<template>
  <div id="front-app">

    <css_methods v-if="$store.state.config !== '' "></css_methods>

    <transition name="trans-loader">
      <loader v-if="$store.state.loader"></loader>
    </transition>

    <div id="header-app"><img src="./assets/img/logo.png"/></div>

    <router-view v-show="$store.state.config !==''" />

    <div class="checkbox-height-helper"></div>  <!--display none - > keeps checkbox height-->

    <div id="footer-app">
      Revel Responsibly.®<br>
      Copyright 2023 Woodchuck Cidery. &nbsp; | &nbsp; All rights reserved 
    </div>

  </div>
</template>

<script>
  import './assets/sass/core.scss';
  import './assets/sass/custom.scss';
  import Loader from './components/Loader'
  import Css_methods from './components/Css_methods'

  export default {
      name: "App",
      components: {
          'loader': Loader,
          'css_methods': Css_methods,
      },
  }
</script>

<style lang="scss">
</style>